
import DataForm from "./dataForm.vue";
import DataList from "./dataList.vue";
import { ICommentItem } from 'blog';
import Vue, { PropType } from 'vue';
export default Vue.extend({
	props: {
		title: {
			type: String,
			default: "",
		},
		subTitle: {
			type: String,
			default: "",
		},
		list: {
			type: Array as PropType<ICommentItem[]>,
			default: () => [] as ICommentItem[],
		},
		isListLoading: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		DataForm,
		DataList,
	},
})
